<div class="loader-container" *ngIf="(!view || !view?.data)&&!error">
    <app-loading-dots size="5px"></app-loading-dots>
</div>
<app-error-view *ngIf="error">
    <div class="message-box">
      <p class="error-head">404</p>
      <p class="error-message">{{'no_views_found'|translation}}</p>
  
      <div class="buttons-con">
        <div class="action-link-wrap">
          <app-button style="margin: 12px;display: inline-block;" (click)="back()">{{
            "back" | translation
          }}</app-button>
          <app-button style="cursor: pointer;" (click)="home()">{{
            "home" | translation
          }}</app-button>
        </div>
      </div>
    </div>
  </app-error-view>
<div *ngIf="view && view?.data">
    <div style="margin:10px">
        <app-view [items]="view?.data?.content" [info]="view?.data"></app-view>
    </div>
</div>
